import { CSSProperties } from 'react';
import { theme } from '../../theme';
import { isDesktop } from '../../platform';

export const mercadoPagoCardStyles = {
  button: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    // Mobile: padding ajustado para que el contenido entre en la misma proporción que "Agregar tarjeta".
    padding: isDesktop
      ? `${theme.spacing.semiHuge}px ${theme.spacing.mediumLarge}px`
      : `${theme.spacing.medium}px ${theme.spacing.mediumLarge}px`,
    gap: theme.spacing.mediumLarge,
    backgroundColor: theme.colors.mercadopago.background,
    border: `1px solid ${theme.colors.mercadopago.border}`,
    borderRadius: theme.radius.md,
    // Mismo tamaño que las tarjetas en mobile (proporción); desktop conserva su alto mínimo.
    ...(isDesktop
      ? { minHeight: theme.sizes.paymentCard.minHeight }
      : { aspectRatio: theme.sizes.paymentCard.aspectRatio }),
    cursor: 'pointer',
    opacity: 0.8,
    transition: `opacity ${theme.transitions.fast}`,
    fontFamily: theme.typography.fontFamily,
    boxShadow: theme.shadows.sm,
  } as CSSProperties,

  buttonHover: {
    opacity: 1,
  } as CSSProperties,

  buttonDisabled: {
    cursor: 'not-allowed',
    opacity: 0.5,
  } as CSSProperties,

  webButton: {
    border: `1px solid ${theme.colors.palette.blue100}`,
    height: 184,
    transition: `all ${theme.transitions.normal}`,
  } as CSSProperties,

  /** Web, sin seleccionar: 122 px de alto. */
  webButtonCollapsed: {
    minHeight: 122,
    height: 122,
    padding: theme.spacing.medium,
  } as CSSProperties,

  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  } as CSSProperties,

  subtitle: {
    textAlign: 'center',
    color: theme.colors.subtitle,
    fontSize: theme.typography.fontSize.xs,
    lineHeight: theme.typography.lineHeight.xs,
    width: theme.sizes.textWidth.small, // 145 (not in spacing)
    height: 14,
    fontFamily: theme.typography.fontFamily,
    margin: 0,
  } as CSSProperties,
};
